import React from 'react';
import { connect } from 'react-redux';
import { Modal } from 'semantic-ui-react';
import { hideViewCommentsModal } from '../../redux/actions/modals';
import CommentsList from '../shared/CommentsList';

class AddCommentModal extends React.Component {

  handleClose = async () => {
    this.props.hideViewCommentsModal(false)
  }

  render() {
    const { comments } = this.props.modal;
    return (
        <Modal
          open={this.props.modal.open}
          onClose={this.handleClose}
          size='small'
          closeIcon
        >
          <Modal.Header>View Comments</Modal.Header>
          <Modal.Content scrolling>
            <CommentsList comments={comments} />
          </Modal.Content>
        </Modal>
    )
  }
}

const mapStateToProps = state => {
	return {
    modal: state.viewCommentsModal,
  };
};

export default connect(mapStateToProps, { hideViewCommentsModal })(AddCommentModal);


